"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BOOKINGS_LIST_SECTION_ID = exports.BOOKINGS_SCHEDULER_SECTION_ID = exports.BOOKINGS_CHECKOUT_SECTION_ID = exports.BOOKINGS_LIST_PAGE_ID = exports.BOOKINGS_MAIN_PAGE_ID = exports.BOOKINGS_OFFERING_LIST_WIDGET_ID = exports.BOOKINGS_WIDGET_ID = exports.BOOKINGS_APP_DEF_ID = void 0;
exports.BOOKINGS_APP_DEF_ID = '13d21c63-b5ec-5912-8397-c3a5ddb27a97';
exports.BOOKINGS_WIDGET_ID = '14756c3d-f10a-45fc-4df1-808f22aabe80';
exports.BOOKINGS_OFFERING_LIST_WIDGET_ID = 'cc882051-73c9-41a6-8f90-f6ebc9f10fe1';
exports.BOOKINGS_MAIN_PAGE_ID = '13d27016-697f-b82f-7512-8e20854c09f6';
exports.BOOKINGS_LIST_PAGE_ID = '621bc837-5943-4c76-a7ce-a0e38185301f';
exports.BOOKINGS_CHECKOUT_SECTION_ID = 'book_checkout';
exports.BOOKINGS_SCHEDULER_SECTION_ID = 'scheduler';
exports.BOOKINGS_LIST_SECTION_ID = 'bookings_list';
//# sourceMappingURL=bookings.consts.js.map